import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

const safePortal = (children: React.ReactNode, container?: Element | null) => {
  if (
    typeof window === 'undefined' ||
    typeof document === 'undefined' ||
    !document.body
  )
    return null;
  return createPortal(children, container ?? document.body);
};

const useSafePortal = () => {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  const createSafePortal = (
    children: React.ReactNode,
    container?: Element | null,
  ) => {
    if (!isMounted) return null;
    return safePortal(children, container);
  };

  return createSafePortal;
};

export default useSafePortal;
